import getCrosstalkData from './helper/crosstalkResultHelper';

export default function getCrosstalk({ verificationSubId, channelId, interfaceName, verificationId, fileName, isMultiResult }) {
    return getCrosstalkData({ verificationSubId, channelId, interfaceName, verificationId, fileName, isMultiResult });
};